<app-data-table
  [columns]="columns"
  [data]="tableRows"
  emptyMessage="No records for the selected filters.">

  <ng-template appColumnCell="studentName" let-row>
    {{ row.studentFirstName }} {{ row.studentLastName }}
  </ng-template>

  <ng-template appColumnCell="startTime" let-row>
    {{ row.startTime | slice:0:5 }}
  </ng-template>

  <ng-template appColumnCell="endTime" let-row>
    {{ row.endTime | slice:0:5 }}
  </ng-template>

  <ng-template appColumnCell="reason" let-row>
    {{ row.reasonDescription || row.reason }}
  </ng-template>

  <ng-template appColumnCell="status" let-row>
    <app-session-status-pill [status]="row.status"></app-session-status-pill>
  </ng-template>
</app-data-table>
